import EADialog from "components/common/EADialog";
import i18next from "i18next";
import useStyles from "./CreditsafePanelStyle";
import clsx from 'clsx';
import EAIcon from "components/common/EAIcon";

const OtherDetailsModal = ({ isOpen, onClose, score, value, color }) => {
    const { classes } = useStyles();

    const size = () => {
        if (score === "dbt" || score === "preferentialStatus") {
            return "small";
        } else if (score === "creditLimit" ) {
            return "x-small";
        } else {
            return "normal";
        }
    }

    return (
        <EADialog
            isOpen={isOpen}
            maxWidth="md"
            hasActions={false}
            onClose={onClose}
            title={i18next.t(`creditsafe.details.${score}.modalTitle`)}
        >
            <div className={classes.scoreDetailValueRisksWrapper}>
                <div className={classes.scoreDetailValueWrapper} style={{background: `radial-gradient(501.19% 107.24% at 7.02% 17.37%, ${color}1a 36.75%, rgba(255, 255, 255, 0.15) 100%), #FFF`}}>
                    <div className={classes.scoreDetailValueTitle}>
                        {i18next.t(`creditsafe.details.${score}.detailValueTitle`)}
                    </div>
                    <div className={clsx(classes.scoreDetailValueSquare, `size-${size()}`)} style={{color: color}}>
                        <EAIcon icon="rectangle" />
                        <div className={classes.scoreDetailValue}>{value}</div>
                    </div>
                </div>

                <div className={classes.scoreDetailRiskWrapper}>
                    <div className={classes.scoreDetailRiskTitle}>
                        {i18next.t(`creditsafe.details.${score}.modalSubTile`)}
                    </div>
                    <div className={classes.scoreDetailRisk}>
                        {i18next.t(`creditsafe.details.${score}.description`)}
                    </div>
                </div>
            </div>

        </EADialog>
    )

}
export default OtherDetailsModal;